import React, { FC } from 'react';
import { HeaderGroup } from 'react-table';
import { IRowData } from 'constants/Table/interfaces';

interface TableShipmentsColumnProps {
  headerGroup: HeaderGroup<IRowData>;
}

const HeaderRow: FC<TableShipmentsColumnProps> = ({ headerGroup }) => {
  return (
    <tr {...headerGroup.getHeaderGroupProps()} style={{ height: 34 }}>
      {headerGroup.headers.map((column, i) => {
        const mainField = column.id === 'name';
        return (
          <th
            className={`normal-case py-1 border-b bg-[#eef2ff] dark:bg-[#0f172a] border-slate-200 dark:border-slate-700 ${i === 0 ? 'sticky z-10 left-0' : 'z-2'}`}
            data-sticky-td={column.id === 'selection' || undefined}
            {...column.getHeaderProps(mainField || column.id === 'selection'
              ? { style: { minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth } }
              : { style: { minWidth: 140 } }
            )}
            key={column.id}
          >
            <div className={`flex text-slate-700 dark:text-slate-200 items-center text-[12px] font-semibold px-1 ${i === 0 ? 'justify-center' : 'justify-start'}`}>
              {column.render('Header')}
            </div>
          </th>
        );
      })}
      <td className="bg-[#eef2ff] dark:bg-[#0f172a]">
        <div className="m-0 p-4 sticky z-10 right-[-0.1rem]" />
      </td>
    </tr>
  );
};

export default HeaderRow
